module.exports = __webpack_public_path__ + "static/media/75.0b5fc66a.gif";